export const LANGUAGE_LEARNING = {
  UPLOAD_FILE: "UPLOAD_FILE"
};
